import { render } from "./SettingTicketTemplateView.vue?vue&type=template&id=085bf2c8"
import script from "./js/settingTicketTemplateView.js?vue&type=script&lang=js&external"
export * from "./js/settingTicketTemplateView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__